import AdvisorPageHero from '@/components/advisor/AdvisorPageHero';
import AdvisorOpportunitiesSections from '@/components/advisor/AdvisorOpportunitiesSections';
import AdvisorSignupForm from '@/components/advisor/AdvisorSignupForm';

function AdvisorOpportunitiesPage() {
  const scrollToSignup = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('advisor-signup')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="fhxd-chrome-top">
      <AdvisorPageHero ctaLabel="Advisor Sign Up" onCtaClick={scrollToSignup} />
      <AdvisorOpportunitiesSections />
      <AdvisorSignupForm />
    </div>
  );
}

export default AdvisorOpportunitiesPage;
